import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.tsx";
import "./styles/global.css";
import "./styles/player.css";

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root");

// Debug mode: ?debug=shader opens the shader calibration harness
const isShaderDebug = new URLSearchParams(window.location.search).get("debug") === "shader";

const ShaderCalibration = lazy(() =>
  import("./debug/ShaderCalibration.tsx").then((m) => ({ default: m.ShaderCalibration })),
);

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    {isShaderDebug ? (
      <Suspense fallback={<div style={{ color: "#fff", padding: "2rem" }}>Loading calibration harness…</div>}>
        <ShaderCalibration />
      </Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);

// PWA registration is added by vite-plugin-pwa at build time.
